import { render } from "./SearchInputButton.vue?vue&type=template&id=71cf8a18&scoped=true"
import script from "./SearchInputButton.vue?vue&type=script&lang=js"
export * from "./SearchInputButton.vue?vue&type=script&lang=js"

import "./SearchInputButton.vue?vue&type=style&index=0&id=71cf8a18&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cf8a18"]])

export default __exports__